export const LOCALSTORAGE_TOKEN = "supervision-token";
